










































































































































import Vue from "vue";
import { Component, Prop, Inject } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { ISelectListItem } from "@everbright/promotions/lib/models";
import { IValidationRules, IPropertyValidationRules } from "@elite/validation";
import { RestClient } from "@elite/restclient";
import { AppGetterTypes, GetPropertyValidationRules } from "../store";

// Note: this is not included in config/index.ts because it will break unit tests (unsure why)
import DefaultTinyMceConfig from "../config/DefaultTinyMceConfig";

// don't inject attributes to the root element - see https://vuejs.org/v2/api/#inheritAttrs
@Component({ inheritAttrs: false })
export default class ValFormInput extends Vue {
    @Inject()
    restClient!: RestClient;

    @Getter(AppGetterTypes.validationRules)
    validationRules!: IValidationRules;

    @Getter(AppGetterTypes.getPropertyValidationRules)
    getPropertyValidationRules!: GetPropertyValidationRules;

    @Prop()
    disabled?: boolean;

    @Prop({ required: true })
    rulesName!: string;

    @Prop()
    type!: string;

    @Prop({ required: true })
    value!: object;

    @Prop({ default: true })
    displayLabel!: boolean;

    @Prop({ default: false })
    disableTextboxAutocomplete!: boolean;

    @Prop()
    id!: string;

    @Prop()
    options?: ISelectListItem[];
    @Prop()
    optionsUrl?: string;

    @Prop({ default: false })
    multiple?: boolean;

    mceConfig: DefaultTinyMceConfig = new DefaultTinyMceConfig();

    ajaxOptions: ISelectListItem[] = [];

    propertyErrors: string[] = [];

    get localValue(): object {
        return this.value;
    }
    set localValue(val: object) {
        this.$emit("input", val);
    }

    get rules(): IPropertyValidationRules {
        return this.getPropertyValidationRules(this.rulesName);
    }

    get localOptions(): ISelectListItem[] {
        return this.options || this.ajaxOptions;
    }

    currencyFormatter(value: string | null) {
        if (value) {
            const num = parseFloat(value);

            if (isNaN(num)) {
                return null;
            }

            return num.toFixed(2);
        }

        return null;
    }

    phoneFormatter(value: string) {
        const x = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

        if (x != null) {
            value = !x[2]
                ? x[1]
                : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
            return value;
        }

        return null;
    }

    mounted() {
        this.$nextTick(() => {
            this.$root.$on(
                `validate-${this.rules.propertyName}`,
                (errors: string[]) => {
                    this.propertyErrors = errors;
                }
            );
        });

        if (this.type === "select" && this.optionsUrl) {
            this.restClient
                .getJson<ISelectListItem[]>(this.optionsUrl)
                .then(response => {
                    this.ajaxOptions = response.data || [];
                });
        }
    }

    search(search: string, loading: (isLoading: boolean) => void): void {
        this.$emit("search", search, loading);
    }
}
